import { login, loginOut } from '../../api/login.js'
// import md5 from 'js-md5';
// var hostname = window.location.hostname;
// var env = getEnv();
// function getEnv() {
//   switch (hostname) {
//     case 'scm-dev.sao.so':
//       return 'https://scm-api-dev.sao.so';
//     case 'scm.sao.so':
//       return 'https://scm-api.sao.so';
//     case 'localhost':
//       return 'https://scm-api-dev.sao.so';
//     default:
//       break;
//   }
// };
// var devtoken = '901f851621c04ee7da65ee17eb3cfcca'//dev环境token
var devtoken = '281a10a70c6768fec8649705c8d2d060'//生产环境token

import * as Msal from "@azure/msal-browser"; // if using CDN, 'Msal' will be available in global scope
let clientId = "085dbedd-ab63-4c82-a110-997d3ccd16c7"//"01b6aa65-5935-4e33-bf94-557a03c3cddb"
const tenantId = "3ce34e42-c07d-47bb-b72a-4ce606de6b88"//"1b3b698e-3e7e-4fc4-99b0-4164fd0ae0b1"
const authority = "https://login.microsoftonline.com/3ce34e42-c07d-47bb-b72a-4ce606de6b88"//"https://login.microsoftonline.com/organizations"//"https://login.partner.microsoftonline.cn/organizations"

export default {
    state: {
        userName: localStorage.getItem('userName') || '',
        userId: localStorage.getItem('userId') || '',
        token: localStorage.getItem(devtoken) || '',
        islogin: false,
        isloading: false,

    },
    getters: {
        // getuserName(state) {
        //     return state.name
        // },
        getuserId(state) {
            return state.userId
        },
        getuserName(state) {
            return state.userName
        },
        getToken(state) {
            return state.token
        },
        // 是否登录状态
        islogin(state) {
            return state.islogin
        },
        isloading(state) {
            return state.isloading
        }
    },
    mutations: {
        setToken: (state, token) => {
            state.token = token
            //可以单独抽出一个方法
            // localStorage.setItem(devtoken,token)
        },
        //  是否登录
        IS_LOGIN(state, flag) {
            state.islogin = flag
        },
        IS_LOADING(state, flag) {
            state.isloading = flag
        },
        setUserId: (state, userId) => {
            //  state.userId= userId
            // localStorage.setItem('userId',userId)
        },
        //  设置用户名
        setUserName(state, name) {
            state.userName = name
            // localStorage.setItem('userName',name)
        }
    },
    actions: {
        // 登录
        handleLogin({ commit }, { userName, password, authCode }) {
            return new Promise((resolve, reject) => {
                login({
                    userName,
                    password,
                    authCode
                }).then(res => {
                    //  alert(JSON.stringify(res));
                    if (res.data.code == 1000) {
                        // 登录成功存取token
                        commit('IS_LOGIN', true);
                        commit('setToken', res.data.data.token)
                        localStorage.setItem(devtoken, res.data.data.token);
                        commit('setUserId', res.data.data.userId)
                        localStorage.setItem('userId', res.data.data.userId);
                        commit('setUserName', res.data.data.name)
                        localStorage.setItem('userName', res.data.data.name);
                        localStorage.setItem('userNameNew', res.data.data.userName);
                    }
                    resolve(res)
                }).catch((err) => {

                    reject(err)
                });
            })
        },
        // 登出
        async logout({ commit }) {
            const homeAccountId = localStorage.getItem('homeAccountId')
            if (homeAccountId) {//微软登出
                // $cookies.isKey('accessToken')?$cookies.remove('accessToken',-1,'/'):"";
                await localStorage.setItem('logoutload',true)
                let redirectUri = '', postLogoutRedirectUri = ''
                if (window.location.host.indexOf('qrcodeuat.kraftheinz.net.cn') != -1) {
                    redirectUri = "https://qrcodeuat.kraftheinz.net.cn/index.html";
                    postLogoutRedirectUri = "https://qrcodeuat.kraftheinz.net.cn/index.html";//window.location.host;
                } else if (window.location.host.indexOf('qrcode.kraftheinz.net.cn') != -1) {
                    clientId = "2f956185-93bf-4f7c-aec3-6b6699b5ccc7"
                    redirectUri = "https://qrcode.kraftheinz.net.cn/";
                    postLogoutRedirectUri = "https://qrcode.kraftheinz.net.cn/";//window.location.host;
                }
                const config = { auth: { clientId, redirectUri, postLogoutRedirectUri, tenantId, authority } }
                let accountId = "";
                const myMsal = new Msal.PublicClientApplication(config);

                // you can select which account application should sign out
                const logoutRequest = {
                    account: myMsal.getAccountByHomeId(homeAccountId),
                    mainWindowRedirectUri: postLogoutRedirectUri
                }
                await myMsal.logoutPopup(logoutRequest)
                await $cookies.isKey('accessToken')?$cookies.set('accessToken','',60):"";
                await $cookies.isKey('USERLANGUAGE')?$cookies.set('USERLANGUAGE',"",60):'';
                await localStorage.removeItem('homeAccountId');
                await localStorage.removeItem("logoutload");
                // await $cookies.isKey('USERLANGUAGE')?$cookies.remove('USERLANGUAGE',-1,'/'):"";
                // await $cookies.isKey('accessToken')?$cookies.remove('accessToken',-1,'/'):"";
                
            }
            return new Promise((resolve, reject) => {
                loginOut({}).then(res => {
                    if (res.data.code == 1000) {
                        localStorage.removeItem('281a10a70c6768fec8649705c8d2d060')
                        localStorage.removeItem('userId')
                        localStorage.removeItem('userName')
                        localStorage.removeItem('homePagemenus')
                        // 清除面包屑 
                        localStorage.removeItem('breakFirst')
                        localStorage.removeItem('breakTwo')
                        // 清除企业code
                        localStorage.removeItem('eseCode')
                    }
                    resolve(res)
                }).catch((err) => {

                    reject(err)
                })
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/module/user.js